var render = function render(){var _vm=this,_c=_vm._self._c;return _c('H5Layout',{attrs:{"title":"用户管理","active":""}},[_c('ZUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }